import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { SharedModule } from 'lib-trend-core';
import { ChatMessageStatusComponent } from './chat-message-status/chat-message-status.component';
import { MenuActionsComponent } from './menu-actions.component';
import { ChatMessageAudioTranscriptionComponent } from './chat-message-audio-transcription/chat-message-audio-transcription.component';

@NgModule({
  imports: [
    SharedModule,
    PickerModule
  ],
  declarations: [
    MenuActionsComponent,
    ChatMessageStatusComponent,
    ChatMessageAudioTranscriptionComponent
  ],
  exports: [
    MenuActionsComponent,
    ChatMessageStatusComponent
  ],
  providers: [

  ],
  schemas: [NO_ERRORS_SCHEMA]
})

export class MenuActionsModule { }
